import React from 'react'
import * as styles from './field-label.module.css'
import cx from 'classnames'
import { ClassNamesApiProps } from '@cinch/design-system/src/components/types'

export interface FormLabelClassNameProps {
  label?: string
}

export interface FormLabelProps extends ClassNamesApiProps<FormLabelClassNameProps> {
  htmlFor: string
  children: React.ReactNode
}

const FormLabel: React.FC<FormLabelProps> = ({ htmlFor, children, classNames }) => {
  return (
    <label htmlFor={htmlFor} className={cx(styles.label, classNames?.label)} data-testid="FormLabel">
      {children}
    </label>
  )
}

export default FormLabel
